import { useRouter } from 'vue-router';

import { checkForUpdatesAndReload, triggerPushSubscription } from '@/registerServiceWorker';
import { useAuthStore } from '@/store/authStore';

export async function navigateTo(router: ReturnType<typeof useRouter>, path: string) {
    // 🚀avigate immediately
    router.push(path);

    // Start non-critical operations in the background
    handlePostNavigationTasks();
}

async function handlePostNavigationTasks() {
    const authStore = useAuthStore();
    const userProfile = authStore.getUserProfile();

    console.log('Post-navigation: Notification permission:', Notification.permission);
    console.log('Post-navigation: User profile:', userProfile);

    const hasServiceWorkerSupport = 'serviceWorker' in navigator;

    if (userProfile && userProfile.id && hasServiceWorkerSupport) {
        try {
            await triggerPushSubscription();
        } catch (err) {
            console.warn('triggerPushSubscription failed:', err);
        }
    } else {
        console.log('Skipping triggerPushSubscription (not supported or no userProfile)');
    }

    try {
        await checkForUpdatesAndReload();
    } catch (err) {
        console.warn('checkForUpdatesAndReload failed:', err);
    }
}

export function navigateToFeed() {
    console.log('Navigating to (navigateToFeed) feed');
    window.location.href = '/post-feed-view?reset';
}
